<template>
  <div v-if="!isPageLoading">
    <v-card>
      <v-toolbar dark flat>
        <v-app-bar-nav-icon></v-app-bar-nav-icon>

        <v-toolbar-title>New Medical Application Request</v-toolbar-title>

        <v-spacer></v-spacer>
        <!-- <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn> -->

      </v-toolbar>
      <!-- <template v-slot:extension> -->
      <v-tabs align-with-title v-model="tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>

        <v-tab key="tab_1" href="#tab_1"> Your Contact Info </v-tab>
        <v-tab key="tab_2" href="#tab_2"> Converter/Distributor </v-tab>
        <v-tab key="tab_3" href="#tab_3"> Product/Application </v-tab>
      </v-tabs>
      <!-- </template>
      </v-toolbar> -->
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-tabs-items v-model="tab">
          <v-tab-item key="tab_1" value="tab_1">
            <v-container fluid>
              <!-- <v-card style="overflow: auto"> -->
                
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-select
                    outlined
                    hide-details
                    dense
                    label="Are you a Distributor or Converter?"
                    :rules="rules.dropdown"
                    v-model="DistributorOrConverter"
                    :items="selectDistributorConverter"
                    item-text="text"
                    item-value="value"
                    required
                    @change="DistributorOrConverterSelected()"
                  ></v-select>   
                </v-col>             
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.submitterName"
                    :rules="rules.name"
                    label="Your Full name"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedSubmittername && defaultItem.submitterName.length >= 50"
                    :error-messages="isFocusedSubmittername && defaultItem.submitterName.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedSubmittername=true"
                    @blur="isFocusedSubmittername=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.submitterEmail"
                    :rules="rules.Email"
                    label="Your Email"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedSubmitteremail && defaultItem.submitterEmail.length >= 50"
                    :error-messages="isFocusedSubmitteremail && defaultItem.submitterEmail.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedSubmitteremail=true"
                    @blur="isFocusedSubmitteremail=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-btn depressed color="primary" @click="changeTab('tab_2')"
                    >Next</v-btn
                  >
                </v-col>
              </v-row>
              <!-- </v-card> -->
            </v-container>
          </v-tab-item>

          <!-- Converter Information-->
          <!--*************************************************************************-->
          <v-tab-item key="tab_2" value="tab_2">
            <v-container fluid>
              <!-- <v-card style="overflow: auto"> -->
              <v-row v-if="DistributorOrConverter == 'Y'">
                <v-col cols="12" sm="6" md="3">
                   <v-text-field
                    v-model="purchaseDirectly"   
                    :rules="rules.name"
                    label="Purchased Directly From LYB"
                    maxlength="100"
                    dense
                    outlined
                    readonly
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row v-if="DistributorOrConverter == 'N'">
                <v-col cols="12" sm="6" md="3">
                  <v-select
                    outlined
                    hide-details
                    dense
                    label="Purchased Directly From LYB"
                    :rules="rules.dropdown"
                    v-model="purchaseDirectly"
                    :items="selectYesNo"
                    item-text="text"
                    item-value="value"
                    required
                    @change="purchasedFromLybDirectlySelected()"
                  ></v-select>   
                </v-col>  
              </v-row>

              <v-row dense>
                <v-tooltip right>
                 <template v-slot:activator="{ on, attrs }">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterParentCompanyName"
                    :rules="rules.name"
                    label="Converter Parent Company"
                    maxlength="50"
                    dense
                    outlined
                    required
                    v-bind="attrs"
                    v-on="on"
                    :error="isFocusedConverterparentcompanyname && defaultItem.converterParentCompanyName.length >= 50"
                    :error-messages="isFocusedConverterparentcompanyname && defaultItem.converterParentCompanyName.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedConverterparentcompanyname=true"
                    @blur="isFocusedConverterparentcompanyname=false"
                  ></v-text-field>
                </v-col>
              </template>               
                 <span>A converter is an organization that transforms raw materials to a medical device, pharmaceutical packaging, etc.</span>
               </v-tooltip>  
                <!-- <v-col cols="12" sm="6" md="9">
                    <p>A converter is an organization that transforms raw materials to a medical device, pharmaceutical packaging, etc.</p>
                </v-col>  -->
              </v-row>
              <v-row dense v-if="purchaseDirectly == 'Yes' || purchaseDirectly == 'N'">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.distributorName"
                    :rules="rules.name"
                    label="Distributor Name"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedDistributorname && defaultItem.distributorName.length >= 50"
                    :error-messages="isFocusedDistributorname && defaultItem.distributorName.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedDistributorname=true"
                    @blur="isFocusedDistributorname=false"
                  ></v-text-field>
                </v-col>
                <v-col> </v-col>
              </v-row>
              <v-row dense v-if="purchaseDirectly == 'Yes'|| purchaseDirectly == 'N'">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.distributorCountry"
                    :rules="rules.name"
                    label="Distributor Country"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedDistributorcountry && defaultItem.distributorCountry.length >= 50"
                    :error-messages="isFocusedDistributorcountry && defaultItem.distributorCountry.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedDistributorcountry=true"
                    @blur="isFocusedDistributorcountry=false"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterName"
                    :rules="rules.name"
                    label="Converter Name"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedConvertername && defaultItem.converterName.length >= 50"
                    :error-messages="isFocusedConvertername && defaultItem.converterName.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedConvertername=true"
                    @blur="isFocusedConvertername=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterAddress"
                    :rules="rules.name"
                    label="Converter Address"
                    maxlength="500"
                    dense
                    outlined
                    required
                    :error="isFocusedConverteraddress && defaultItem.converterAddress.length >= 500"
                    :error-messages="isFocusedConverteraddress && defaultItem.converterAddress.length >= 500 ? ['Maximum 500 characters allowed'] : []"
                    @focus="isFocusedConverteraddress=true"
                    @blur="isFocusedConverteraddress=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterAddress2"
                    label="Converter Address 2nd Line"
                    maxlength="500"
                    dense
                    outlined
                    :error="isFocusedConverteraddress2 && defaultItem.converterAddress2.length >= 500"
                    :error-messages="isFocusedConverteraddress2 && defaultItem.converterAddress2.length >= 500 ? ['Maximum 500 characters allowed'] : []"
                    @focus="isFocusedConverteraddress2=true"
                    @blur="isFocusedConverteraddress2=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterCity"
                    :rules="rules.name"
                    label="Converter City"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedConvertercity && defaultItem.converterCity.length >= 50"
                    :error-messages="isFocusedConvertercity && defaultItem.converterCity.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedConvertercity=true"
                    @blur="isFocusedConvertercity=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterState"
                    :rules="rules.name"
                    label="Converter State / Province"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedConverterstate && defaultItem.converterState.length >= 50"
                    :error-messages="isFocusedConverterstate && defaultItem.converterState.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedConverterstate=true"
                    @blur="isFocusedConverterstate=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterZip"
                    :rules="rules.name"
                    label="Converter Zip"
                    maxlength="20"
                    dense
                    outlined
                    required
                    :error="isFocusedConverterzip && defaultItem.converterZip.length >= 20"
                    :error-messages="isFocusedConverterzip && defaultItem.converterZip.length >= 20 ? ['Maximum 20 characters allowed'] : []"
                    @focus="isFocusedConverterzip=true"
                    @blur="isFocusedConverterzip=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterCountry"
                    :rules="rules.name"
                    label="Converter Country"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedConvertercountry && defaultItem.converterCountry.length >= 50"
                    :error-messages="isFocusedConvertercountry && defaultItem.converterCountry.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedConvertercountry=true"
                    @blur="isFocusedConvertercountry=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterContactName"
                    :rules="rules.name"
                    label="Converter Contact Name"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedConvertercontactname && defaultItem.converterContactName.length >= 50"
                    :error-messages="isFocusedConvertercontactname && defaultItem.converterContactName.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedConvertercontactname=true"
                    @blur="isFocusedConvertercontactname=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterPhone"
                    :rules="rules.name"
                    label="Converter Contact Phone with country code"
                    maxlength="20"
                    dense
                    outlined
                    required
                    :error="isFocusedConverterphone && defaultItem.converterPhone.length >= 20"
                    :error-messages="isFocusedConverterphone && defaultItem.converterPhone.length >= 20 ? ['Maximum 20 characters allowed'] : []"
                    @focus="isFocusedConverterphone=true"
                    @blur="isFocusedConverterphone=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.converterContactEmail"
                    :rules="rules.Email"
                    label="Converter Contact Email"
                    maxlength="50"
                    dense
                    outlined
                    required
                    :error="isFocusedConvertercontactemail && defaultItem.converterContactEmail.length >= 50"
                    :error-messages="isFocusedConvertercontactemail && defaultItem.converterContactEmail.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedConvertercontactemail=true"
                    @blur="isFocusedConvertercontactemail=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.AccountManagerSalesContact"
                    :rules="rules.Email"
                    label="LYB Account/LYB Sales Manager Email"
                    maxlength="500"
                    dense
                    outlined
                    required
                    :error="isFocusedAccountmanagersalescontact && defaultItem.AccountManagerSalesContact.length >= 500"
                    :error-messages="isFocusedAccountmanagersalescontact && defaultItem.AccountManagerSalesContact.length >= 500 ? ['Maximum 500 characters allowed'] : []"
                    @focus="isFocusedAccountmanagersalescontact=true"
                    @blur="isFocusedAccountmanagersalescontact=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-tooltip right>
                 <template v-slot:activator="{ on, attrs }">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.EndUser"
                    label="End User"
                    maxlength="50"
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on" 
                    :error="isFocusedEnduser && defaultItem.EndUser.length >= 50"
                    :error-messages="isFocusedEnduser && defaultItem.EndUser.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                    @focus="isFocusedEnduser=true"
                    @blur="isFocusedEnduser=false"
                  ></v-text-field>                   
                </v-col>
              </template>               
                 <span>An end user is an organization that is a marketer of a medical device or pharmaceutical packaging</span>
               </v-tooltip>  
     
              </v-row>
              <!-- <v-row dense>
                 <v-col cols="12" md="12">
                    <p>An end user is an organization that is a marketer of a medical device or pharmaceutical packaging</p>
                 </v-col> 
              </v-row> -->
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.RequestedDocumentation"
                    label="Requested Documentation"
                    maxlength="500"
                    dense
                    outlined
                    :error="isFocusedRequesteddocumentation && defaultItem.RequestedDocumentation.length >= 500"
                    :error-messages="isFocusedRequesteddocumentation && defaultItem.RequestedDocumentation.length >= 500 ? ['Maximum 500 characters allowed'] : []"
                    @focus="isFocusedRequesteddocumentation=true"
                    @blur="isFocusedRequesteddocumentation=false"
                  ></v-text-field>                   
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-btn depressed color="primary" @click="changeTab('tab_1')"
                    >Back</v-btn
                  >&nbsp;&nbsp;
                  <v-btn depressed color="primary" @click="changeTab('tab_3')"
                    >Next</v-btn
                  >
                </v-col>
              </v-row>
              <!-- </v-card> -->
            </v-container>
          </v-tab-item>
          <v-tab-item key="tab_3" value="tab_3">
            <v-container fluid>
              <v-row>                
                <v-tooltip right>
                 <template v-slot:activator="{ on, attrs }">
                  <v-col cols="12" sm="6" md="3">
                  <v-autocomplete
                    outlined
                    hide-details
                    dense
                    label="Product Requested"
                    :rules="rules.dropdown"
                    v-model="defaultItem.productId"
                    :items="productList"
                    item-text="Name"
                    item-value="Id"
                    required
                    v-bind="attrs"
                    v-on="on"
                    @change="productSelected()" 
                  ></v-autocomplete>
                </v-col>
                 </template>               
                 <span>Select from drop down list or begin typing product name</span>
               </v-tooltip>
                <!-- <v-col cols="12" sm="6" md="9">
                    <p>Select from drop down list or begin typing product name</p>
                </v-col>  -->
              </v-row>
              <v-row dense v-if="defaultItem.productId == otherProductId">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.productName"
                    :rules="rules.name"
                    label="Product Name (One Product Only)"
                    maxlength="250"
                    dense
                    outlined
                    required
                    :error="isFocusedProductname && defaultItem.productName.length >= 250"
                    :error-messages="isFocusedProductname && defaultItem.productName.length >= 250 ? ['Maximum 250 characters allowed'] : []"
                    @focus="isFocusedProductname=true"
                    @blur="isFocusedProductname=false"
                  ></v-text-field>
                </v-col>
              </v-row>              
              <v-row>
                <v-tooltip right>
                 <template v-slot:activator="{ on, attrs }">
                  <v-col cols="12" sm="6" md="3">
                  <v-autocomplete
                    outlined
                    hide-details
                    dense
                    label="Region Product Sold"
                    v-model="defaultItem.productSoldRegionId"
                    :items="productRegionList"
                    :rules="rules.dropdown"
                    item-text="ItemValue"
                    item-value="Id"
                    required
                    v-bind="attrs"
                    v-on="on"
                  ></v-autocomplete>
                  </v-col>
                 </template>               
                 <span> Region where the initial  LYB product sale took place</span>
                </v-tooltip>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="defaultItem.productEstimatedVolume"
                    :rules="rules.name"
                    label="Annual estimated Volume"
                    maxlength="30"
                    dense
                    outlined
                    required
                    :error="isFocusedProductEstimatedVolume && defaultItem.productEstimatedVolume.length >= 30"
                    :error-messages="isFocusedProductEstimatedVolume && defaultItem.productEstimatedVolume.length >= 30 ? ['Maximum 30 characters allowed'] : []"
                    @focus="isFocusedProductEstimatedVolume=true"
                    @blur="isFocusedProductEstimatedVolume=false"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-select
                    outlined
                    hide-details
                    dense
                    label="Unit of Measurement"
                    :rules="rules.dropdown"
                    v-model="defaultItem.productUomId"
                    :items="productUomList"
                    item-text="ItemValue"
                    item-value="Id"
                    required
                  ></v-select>
                </v-col>
              </v-row>
              <v-row dense> 
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">               
                <v-col cols="12" sm="6" md="3">
                  <v-select
                    outlined
                    hide-details
                    dense
                    label="Product Application"
                    :rules="rules.dropdown"
                    v-model="defaultItem.productApplicationId"
                    :items="productApplicationList"
                    item-text="ItemValue"
                    item-value="Id"
                    required
                    v-bind="attrs"
                    v-on="on"                 
                  ></v-select>
                </v-col>               
                </template>
                <span  v-if="defaultItem.productApplicationId == medicalDeviceApplication">A medical device is an instrument, apparatus, implement, machine, contrivance, implant, in vitro reagent,
                    or other similar or related article, including any component, part, or accessory, which is intended for use 
                    in the diagnosis of disease or other conditions, or in the cure, mitigation, treatment, or prevention of disease
                    in humans or other animals, or is intended to affect the structure
                     or function of the body of humans or other animals</span>
                <span v-if="defaultItem.productApplicationId == medicalPackagingApplication">Pharmaceutical packaging is packaging in direct contact with a pharmaceutical active ingredient and/or dosage form</span>
               </v-tooltip>  
              </v-row>
            <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication">
                <v-col cols="12" sm="6" md="3">                   
                <v-select
                    outlined
                    hide-details
                    dense
                    label="Device Type"
                    :rules="rules.dropdown"
                    v-model="defaultItem.deviceTypeId"
                    :items="deviceTypeList"
                    item-text="DeviceType"
                    item-value="Id"
                    required
                ></v-select>  
                </v-col>
            </v-row>        
          <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication">
            <v-col cols="12" sm="6" md="3">                   
              <v-select
                outlined
                hide-details
                dense
                label="Classification"
                :rules="rules.dropdown"
                v-model="defaultItem.productClassificationId"
                :items="classificationList"
                item-text="Name"
                item-value="Id"
                required
              ></v-select>  
            </v-col>
          </v-row>    
          
          <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication && (defaultItem.productClassificationId == EUCouncilDirective1990 || defaultItem.productClassificationId == EUCouncilDirective1998 )">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="defaultItem.SpecifyClassification"
                :rules="rules.name"
                label="Specify Classification"
                maxlength="500"
                dense
                outlined
                required
                :error="isFocusedSpecifyclassification && defaultItem.SpecifyClassification.length >= 500"
                :error-messages="isFocusedSpecifyclassification && defaultItem.SpecifyClassification.length >= 500 ? ['Maximum 500 characters allowed'] : []"
                @focus="isFocusedSpecifyclassification=true"
                @blur="isFocusedSpecifyclassification=false"
              ></v-text-field>
            </v-col>
          </v-row>  
          
          <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication && defaultItem.productClassificationId == MedicalDeviceregulatedbyauthorityotherthanFDAorEU">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="defaultItem.OtherRegulatoryAuthority"
                :rules="rules.name"
                label="Specified Other Regulatory Authority"
                maxlength="500"
                dense
                outlined
                required
                :error="isFocusedOtherregulatoryauthority && defaultItem.OtherRegulatoryAuthority.length >= 500"
                :error-messages="isFocusedOtherregulatoryauthority && defaultItem.OtherRegulatoryAuthority.length >= 500 ? ['Maximum 500 characters allowed'] : []"
                @focus="isFocusedOtherregulatoryauthority=true"
                @blur="isFocusedOtherregulatoryauthority=false"
              ></v-text-field>
            </v-col>
          </v-row>           
          <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication && (defaultItem.productClassificationId == FDAClassI || defaultItem.productClassificationId == FDAClassII || defaultItem.productClassificationId == FDAClassIII)">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="defaultItem.fdaCfrCitation"
                :rules="rules.name"
                label="FDA CFR Citation"
                maxlength="500"
                dense
                outlined
                required
                :error="isFocusedFdacfrcitation && defaultItem.fdaCfrCitation.length >= 500"
                :error-messages="isFocusedFdacfrcitation && defaultItem.fdaCfrCitation.length >= 500 ? ['Maximum 500 characters allowed'] : []"
                @focus="isFocusedFdacfrcitation=true"
                @blur="isFocusedFdacfrcitation=false"
              ></v-text-field>
            </v-col>  
          </v-row>
          <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication">
            <v-col cols="12" sm="6" md="3">                   
              <v-select
                outlined
                hide-details
                dense
                label="Duration of Use"
                :rules="rules.dropdown"
                v-model="defaultItem.durationOfUseId"
                :items="this.durationOfUseList"
                item-text="ItemValue"
                item-value="Id"
                required
              ></v-select>  
            </v-col>
          </v-row>        
         <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication">
            <v-col cols="12" sm="6" md="3">                   
              <v-select
                outlined
                hide-details
                dense
                label="Sterilization Method"
                :rules="rules.dropdown"
                v-model="defaultItem.sterilizationMethodId"
                :items="sterilizationMethodList"
                item-text="ItemValue"
                item-value="Id"
                required
                @change="sterilizationMethodSelected()"
              ></v-select>  
            </v-col>
          </v-row>     
          <v-row dense v-if="defaultItem.productApplicationId == medicalDeviceApplication && defaultItem.sterilizationMethodId == otherSterilizationMethodId">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="defaultItem.sterilizationMethodName"
                label="Sterilization Method Name"
                maxlength="50"
                dense
                outlined
                required
                :error="isFocusedSterilizationmethodname && defaultItem.sterilizationMethodName.length >= 50"
                :error-messages="isFocusedSterilizationmethodname && defaultItem.sterilizationMethodName.length >= 50 ? ['Maximum 50 characters allowed'] : []"
                @focus="isFocusedSterilizationmethodname=true"
                @blur="isFocusedSterilizationmethodname=false"
              ></v-text-field>
            </v-col>
          </v-row>  
         <v-row dense v-if="defaultItem.productApplicationId == medicalPackagingApplication">
            <v-col cols="12" sm="6" md="3">                   
              <v-select
                outlined
                hide-details
                dense
                label="Packaging Type"
                :rules="rules.dropdown"
                v-model="defaultItem.packagingTypeId"
                :items="packageTypeList"
                item-text="ItemValue"
                item-value="Id"
                required
              ></v-select>  
            </v-col>
          </v-row>    
          <v-row dense v-if="defaultItem.productApplicationId == medicalPackagingApplication">
            <v-col cols="12" sm="6" md="3">                   
              <v-select
                outlined
                hide-details
                dense
                label="Route of Administration"
                :rules="rules.dropdown"
                v-model="defaultItem.routeOfAdministrationId"
                :items="routeOfAdministrationList"
                item-text="RouteName"
                item-value="Id"
                required
              ></v-select>  
            </v-col>
          </v-row>
              <v-row dense >
                <v-tooltip right>
                 <template v-slot:activator="{ on, attrs }">
                <v-col cols="12" sm="6" md="3">
                  <v-textarea
                    v-model="defaultItem.applicationDetail"
                    :rules="rules.name"
                    label="Product Application Details"
                    maxlength="4000"
                    dense
                    outlined
                    auto-grow
                    required  
                    v-bind="attrs"
                    v-on="on"
                    :error="isFocusedApplicationdetail && defaultItem.applicationDetail.length >= 4000"
                    :error-messages="isFocusedApplicationdetail && defaultItem.applicationDetail.length >= 4000 ? ['Maximum 4000 characters allowed'] : []"
                    @focus="isFocusedApplicationdetail=true"
                    @blur="isFocusedApplicationdetail=false"              
                  >
                  </v-textarea>
                </v-col>
              </template>               
                 <span>Provide a detailed, specific description of use of the product.  Information to provide, as appropriate:
                    What interaction is there with the human body?  What substances contact resin and then return to the human body?
                    Photos or website links are recommended and encouraged.
                    Is it a new or existing application?
                    If packaging, exactly what is being packaged?</span>
               </v-tooltip>               
               </v-row>
              <v-row dense>
                 <v-col cols="12" md="10">
                    <h2>Optional Photo:</h2>
                    <v-file-input
                    show-size
                    small-chips
                    multiple
                    label="Select Image File(s) (File Type: gif, jpg, png, bmp, tiff; Size limit: 1 MB; Filename length limit: 50):"
                    v-model="fileinput"
                    @change="selectFile"
                    accept="image/*"
                    truncate-length="50"
                    clearable
                    ></v-file-input>
                 </v-col> 
              </v-row>
              <v-row dense> 
                <v-col cols="12" sm="6" md="3">
                  <div>
                    <label for="robot" class="col-sm-2 col-form-label"></label>
                    <div class="col-sm-10">
                      <vue-recaptcha ref="recaptcha"
                        @verify="onVerify" @expired="onExpired" sitekey="6LcEluYfAAAAALCX1_tLaKH_O5Pgxf_WD4pTs4I4">
                      </vue-recaptcha>
                    </div>
                  </div>              
                 </v-col>
              </v-row> 
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-btn depressed color="primary" @click="changeTab('tab_2')">Back</v-btn>&nbsp;&nbsp;
                  <v-btn depressed color="primary" @click="save" v-if="!this.startAnother">Submit Request</v-btn> 
                  <v-btn depressed color="primary" @click="setUpForResubmit" v-if="this.startAnother">Start Another Request</v-btn>
                </v-col>
              </v-row>
              <!-- <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <div id="error" v-show="statusmessages.length > 0">
                    <v-alert :value="true" type="error">
                      <div>
                            {{ statusmessages[0] }}
                      </div>
                    </v-alert>
                </div>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12" sm="6" md="3"> 
                  &nbsp;
                </v-col>
              </v-row>
              <!-- <v-card style="overflow: auto"> -->

              <!-- </v-card> -->
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-form>
    </v-card>
  </div>
  <div v-else>
    <v-progress-linear
      indeterminate
      color="teal"
      rounded
      height="8"
    ></v-progress-linear>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import requestsMixin from "../mixins/requests-mixin";
import appMixin from "../mixins/app-mixin";
import {VueRecaptcha} from 'vue-recaptcha';

  export default {
    components: { 
      'vue-recaptcha': VueRecaptcha 
    },
    mixins: [requestsMixin, appMixin],
    data() {
      
      return {
        validateRecaptcha: false,
        generalMasterDatas: null,
        isPageLoading : true,
        isFocusedSubmittername: false,
        isFocusedSubmitteremail: false,
        isFocusedConverterparentcompanyname: false,
        isFocusedDistributorname: false,
        isFocusedDistributorcountry: false,
        isFocusedConvertername: false,
        isFocusedConverteraddress: false,
        isFocusedConverteraddress2: false,
        isFocusedConvertercity: false,
        isFocusedConverterstate: false,
        isFocusedConverterzip: false,
        isFocusedConvertercountry: false,
        isFocusedConvertercontactname: false,
        isFocusedConverterphone: false,
        isFocusedConvertercontactemail: false,
        isFocusedAccountmanagersalescontact: false,
        isFocusedEnduser: false,
        isFocusedRequesteddocumentation: false,
        isFocusedProductname: false,
        isFocusedProductEstimatedVolume: false,
        isFocusedSpecifyclassification: false,
        isFocusedOtherregulatoryauthority: false,
        isFocusedFdacfrcitation: false,
        isFocusedSterilizationmethodname: false,
        isFocusedApplicationdetail: false,
        fileinput: null,
        totalFileSize: 0,
        defaultItem : {
          id: 0,
          requestDate: null,
          submitterName: '',
          submitterEmail: '',
          productPurchasedDirectly: false,
          distributorName: '',
          distributorCountry: '',
          converterParentCompanyName: '',
          converterName: '',
          converterAddress: '',
          converterAddress2: '',
          IsDistributorOrConverter:false,
          EndUser:'',
          RequestedDocumentation:'',
          AccountManagerSalesContact:'',
          converterCity: '',
          converterState: '',
          converterCountry: '',
          converterZip: '',
          converterContactName: '',
          converterContactEmail: '',
          converterPhone: '',
          contractId: -1,
          contractComment: '',
          foodContactCompliant: -1,
          foodcontactCompliantComment: '',
          productId: '',
          productTypeId: -1,
          productSoldRegionId: -1,
          productEstimatedVolume: '',
          productUomId: -1,
          productApplicationId: -1,
          productClassificationId: -1,
          fdaCfrCitation: '',     
          OtherRegulatoryAuthority: '', 
          SpecifyClassification:'',
          durationOfUseId: -1,
          sterilizationMethodId: -1,
          sterilizationMethodName: '',
          applicationDetail: '',
          packagingTypeId: -1,
          routeOfAdministrationId: -1,
          deviceTypeId: -1,
          productStewardComment: '',
          approvalStatus: 58,
          lybcategory: '',
          medicalFocalPointId: -1,
          isFastTracked: false,
          isActive: true, 
          createdBy: '',
          createdDate: null,
          lastModifiedBy: '',
          lastModifiedDate: null,
          files: [],
        },
      rules: {
        age: [(val) => val < 10 || `I don't believe you!`],
        name: [(val) => (val || "").length > 0 || "This field is required"],
        Email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+\..+/.test(v) || "E-mail address is not valid",
          (v) => !/[\s,;:()\[\]\/&]/.test(v) || 'Only one email address allowed',
        ],
        dropdown: [(val) => !!val || "This field is required"],
      },
      startAnother: false,
      valid: false,
      emailValidationRegularExpression: '/.+@.+\..+/',
      tab: null,
      purchaseDirectly: '',
      DistributorOrConverter: '',
      selectYesNo: [
        { value: "", text: "" },
        { value: "N", text: "No" },
        { value: "Y", text: "Yes" },
      ],
      selectDistributorConverter: [
        { value: "", text: "" },
        { value: "N", text: "Converter" },
        { value: "Y", text: "Distributor" },
      ],
      robot: true,
      statusmessages: [],
      productList: [],
      productUomList: [],
      productRegionList: [],
      productApplicationList: [],
      durationOfUseList: [],
      packageTypeList: [],
      sterilizationMethodList: [],
      deviceTypeList: [],
      classificationList: [],
      routeOfAdministrationList: [],
      packageTypeList: [],
      medicalDeviceApplication: 1,
      medicalPackagingApplication: 2,
      //naRegion: 31,
      otherSterilizationMethodId: 52,
      FDAClassI : 1,
      FDAClassII : 2,
      FDAClassIII : 3,
      MedicalDeviceregulatedbyauthorityotherthanFDAorEU:10,
      EUCouncilDirective1990:4,
      EUCouncilDirective1998:9,
      otherProductId: 1,

    };
  },
  computed: {
    isMedicalApplication() {
      return this.productApplicationId == 1;
    },   
  },
  mounted() {
    this.getGeneralMasterDataFromAPI();
    this.getDeviceTypeFromAPI();
    this.getClassificationFromAPI();
    this.getProductFromAPI();
    this.getRouteOfAdministrationFromAPI();
  },
  methods: {
    onVerify: function(response){
      debugger;
      if(response) this.robot = false;
    },

    onExpired: function(){
      debugger;
      this.robot = true;
    },

  productSelected() {
      debugger;
       var self = this;
       self.isPageLoading = true;
       if (self.defaultItem.ProductId != self.otherProductId) {
         self.defaultItem.ProductName = '';
          const link =
            this.settings.odataUrl + "/Product?$filter=IsActive eq true and Id eq " + self.defaultItem.ProductId;
          axios
            .get(link, {
              withCredentials: false,
              headers: self.requestHeaders,
              })
              .then((response) => {
                  debugger;
                  self.defatulItem.ProductTypeId = response.data.value[0].ProductTypeId;
              })
              .catch((error) =>  {
                 console.log(error);
              });
              self.isPageLoading = false;
       }
    },

    getGeneralMasterDataFromAPI() {
        debugger;
        var self = this;
        self.isPageLoading = true;
        const link =
            this.settings.odataUrl + "/MasterData?$filter=IsActive eq true";
        axios
            .get(link, {
            withCredentials: false,
            headers: self.requestHeaders,
            })
            .then((response) => {
                debugger;
                self.generalMasterDatas = response.data;
                self.durationOfUseList = this.generalMasterDatas.value.filter((x) => x.ItemGroup == 'DurationOfUse');
                self.productApplicationList = self.generalMasterDatas.value.filter((x) => x.ItemGroup == 'Application');
                self.productUomList = self.generalMasterDatas.value.filter((x) => x.ItemGroup == 'Uom');
                self.productRegionList = self.generalMasterDatas.value.filter((x) => x.ItemGroup == 'Region' && x.ItemValue != 'GLOBAL');
                self.packageTypeList = self.generalMasterDatas.value.filter((x) => x.ItemGroup == 'PackageType');
                self.sterilizationMethodList = self.generalMasterDatas.value.filter((x) => x.ItemGroup == 'SterilizationMethod');
            self.isPageLoading = false;
            })
            .catch((error) => console.log(error));
    },
    getClassificationFromAPI() {
        // debugger;
        var self = this;
        self.isPageLoading = true;
        const link =
            this.settings.odataUrl + "/Classification?$filter=IsActive eq true";
        axios
            .get(link, {
            withCredentials: false,
            headers: self.requestHeaders,
            })
            .then((response) => {
                // debugger;
                self.classificationList = response.data.value;
            self.isPageLoading = false;
            })
            .catch((error) => console.log(error));
    },
    getDeviceTypeFromAPI() {
        // debugger;
        var self = this;
        self.isPageLoading = true;
        const link =
            this.settings.odataUrl + "/DeviceCategory?$filter=IsActive eq true";
        axios
            .get(link, {
            withCredentials: false,
            headers: self.requestHeaders,
            })
            .then((response) => {
                // debugger;
                self.deviceTypeList = response.data.value;
            self.isPageLoading = false;
            })
            .catch((error) => console.log(error));
    },
    getProductFromAPI() {
        // debugger;
        var self = this;
        self.isPageLoading = true;
        const link =
            this.settings.odataUrl + "/Product?$filter=IsActive eq true";
        axios
            .get(link, {
            withCredentials: false,
            headers: self.requestHeaders,
            })
            .then((response) => {
                // debugger;
                self.productList = response.data.value;
            self.isPageLoading = false;
            })
            .catch((error) => console.log(error));
    },
    getRouteOfAdministrationFromAPI() {
        // debugger;
        var self = this;
        self.isPageLoading = true;
        const link =
            this.settings.odataUrl + "/RouteOfAdministration?$filter=IsActive eq true";
        axios
            .get(link, {
            withCredentials: false,
            headers: self.requestHeaders,
            })
            .then((response) => {
                // debugger;
                self.routeOfAdministrationList = response.data.value;
            self.isPageLoading = false;
            })
            .catch((error) => console.log(error));
    },

    validateFields() {
        debugger;
        var self = this;
        var msg = '';
        if (self.defaultItem.submitterName.trim() == ''){ msg = 'Your Contact Info ==> Submitter Name is required.\n'; }
        if (self.defaultItem.submitterEmail.trim() == ''){ msg += 'Your Contact Info ==> Submitter Email is required.\n'; }
        if (self.DistributorOrConverter != 'N' &&  self.DistributorOrConverter != 'Y'){ msg += 'Your Contact Info ==> Distributor Converter selection is required.\n'; }
        if (self.defaultItem.submitterEmail.trim() != '' && !/.+@.+\..+/.test(self.defaultItem.submitterEmail.trim())) 
        { msg += 'Your Contact Info ==> Please enter a valid submitter email.\n'; }
        // if (self.purchaseDirectly != 'No' &&  self.purchaseDirectly != 'Yes'){ msg += 'Converter/Distributor ==> Purchased Directly From LYB is required.\n'; }        
        if (self.defaultItem.converterParentCompanyName == ''){ msg += 'Converter/Distributor ==> Converter Parent Company is required.\n'; }
        if (self.purchaseDirectly == 'Yes')
        {
            if (self.defaultItem.distributorName == ''){ msg += 'Converter/Distributor==> Distributor Name is required.\n'; }
            if (self.defaultItem.distributorCountry == ''){ msg += 'Converter/Distributor==> Distributor Country is required.\n'; }
        }        
        if(self.defaultItem.AccountManagerSalesContact.trim() == '' || self.defaultItem.AccountManagerSalesContact== 'null'){msg+='Converter/Distributor ==> Account/Sales Manager email is required.\n';}
        const rawEmail = self.defaultItem.AccountManagerSalesContact;
        const trimmedEmail = rawEmail.trim();

        if (rawEmail != trimmedEmail) {
          msg += 'Account/Sales Manager email should not contain leading or trailing spaces.\n';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
          msg += 'Your Contact Info ==> Please enter a valid single Account/Sales Manager email. \n';
        }
        // if (self.defaultItem.AccountManagerSalesContact.trim() != '' && !/^[^\/()@]+@[^\/()@]+\.[^\/()@]+$/.test(self.defaultItem.AccountManagerSalesContact.trim()))
        // { msg += 'Your Contact Info ==> Please enter a valid single Account/Sales Manager email. \n'; }

        if (self.defaultItem.converterName == ''){ msg += 'Converter/Distributor ==> Converter Name is required.\n'; }
        if (self.defaultItem.converterAddress == ''){ msg += 'Converter/Distributor ==> Converter Address is required.\n'; }
        if (self.defaultItem.converterCity == ''){ msg += 'Converter/Distributor ==> Converter City is required.\n'; }
        if (self.defaultItem.converterState == ''){ msg += 'Converter/Distributor==> Converter State/Province is required.\n'; }
        if (self.defaultItem.converterZip == ''){ msg += 'Converter/Distributor ==> Converter Zip is required.\n'; }
        if (self.defaultItem.converterCountry == ''){ msg += 'Converter/Distributor ==> Converter Country is required.\n'; }
        if (self.defaultItem.converterContactName == ''){ msg += 'Converter/Distributor ==> Converter Contact Name is required.\n'; }
        if (self.defaultItem.converterPhone == ''){ msg += 'Converter/Distributor ==> Converter Contact Phone is required.\n'; }
        if (self.defaultItem.converterContactEmail.trim() == ''){ msg += 'Converter/Distributor ==> Converter Contact Email is required.\n'; }
        
        const converterEmail = self.defaultItem.converterContactEmail;
        const trimmedmail = converterEmail.trim();
        if (converterEmail != trimmedmail) {
          msg += 'Converter contact email should not contain leading or trailing spaces.\n';
        } else if (!/.+@.+\..+/.test(trimmedmail)) {
          msg += 'Converter/Distributor ==> Please enter a valid converter contact email.\n';
        }      

        if (self.defaultItem.productId == -1 || self.defaultItem.productId == null || self.defaultItem.productId == '') { msg += 'Product/Application ==> Product is required.\n'; }
        if (self.defaultItem.productId == self.otherProductId && self.defaultItem.productName.trim() == '') {msg += 'Product/Application ==> Product name is required.\n'}
        if (self.defaultItem.productSoldRegionId == -1 || self.defaultItem.productSoldRegionId == null || self.defaultItem.productSoldRegionId == '') { msg += 'Product/Application ==> Region product sold is required.\n'; }
        if (self.defaultItem.productEstimatedVolume.trim() == '') { msg += 'Product/Application ==> Estimated volume is required.\n'; }
        if (self.defaultItem.productUomId == -1 || self.defaultItem.productUomId == '') { msg += 'Product/Application ==> Product UOM is required.\n'; }
        if (self.defaultItem.productApplicationId == -1 || self.defaultItem.productApplicationId == '' || self.defaultItem.productApplicationId == null) { msg += 'Product/Application ==> Product application is required.\n'; }       
        
        if (self.defaultItem.productApplicationId == self.medicalDeviceApplication)
        {
          if (self.defaultItem.deviceTypeId == -1 || self.defaultItem.deviceTypeId == '' || self.defaultItem.deviceTypeId == null) { msg += 'Product/Application ==> Device Type is required.\n'; }
          if (self.defaultItem.productClassificationId == -1 || self.defaultItem.productClassificationId == '' || self.defaultItem.productClassificationId == null) { msg += 'Product/Application ==> Classification is required.\n'; }
          if (self.defaultItem.productClassificationId == self.MedicalDeviceregulatedbyauthorityotherthanFDAorEU)
          {
             if (self.defaultItem.OtherRegulatoryAuthority.trim() == '' || self.defaultItem.OtherRegulatoryAuthority=='null' ) { msg += 'Product/Application ==> Specified Other Regulatory Authority is required.\n'; }
          }
          if (self.defaultItem.productClassificationId == self.FDAClassI || self.defaultItem.productClassificationId == self.FDAClassII || self.defaultItem.productClassificationId == self.FDAClassIII )
          {
             if (self.defaultItem.fdaCfrCitation.trim() == '') { msg += 'Product/Application ==> FDA CFR Citation is required.\n'; }
          }
          if(self.defaultItem.productClassificationId == self.EUCouncilDirective1990 ||self.defaultItem.productClassificationId ==self.EUCouncilDirective1998)
          {
            if(self.defaultItem.SpecifyClassification.trim() == '' || self.defaultItem.SpecifyClassification == 'null') { msg += 'Product/Application ==> Specify Classification is required.\n'; }
          }
          if (self.defaultItem.durationOfUseId == -1 || self.defaultItem.durationOfUseId == '' || self.defaultItem.durationOfUseId == null) { msg += 'Product/Application ==> Duration of use is required.\n'; }
          if (self.defaultItem.sterilizationMethodId == -1 || self.defaultItem.sterilizationMethodId == '' || self.defaultItem.sterilizationMethodId == null) { msg += 'Product/Application ==> Sterilization method is required.\n'; }
        }

        if (self.defaultItem.sterilizationMethodId == self.otherSterilizationMethodId && self.defaultItem.sterilizationMethodName.trim() == '')
        {
           { msg += 'Product/Application ==> Sterilization method name is required.\n'; }
        }

        if (self.defaultItem.productApplicationId == self.medicalPackagingApplication)
        {
          if (self.defaultItem.packagingTypeId == -1 || self.defaultItem.packagingTypeId == '' || self.defaultItem.packagingTypeId == null) { msg += 'Product/Application ==> Package Type is required.\n'; }
          if (self.defaultItem.routeOfAdministrationId == -1 || self.defaultItem.routeOfAdministrationId == '' || self.defaultItem.routeOfAdministrationId == null) { msg += 'Product/Application ==> Route of Administration is required.\n'; }
        }

        if (self.defaultItem.applicationDetail.trim() == '') { msg += 'Product/Application ==> Application detail is required.\n'; }
        if (self.defaultItem.files.length > 0)
        {
           for (var i = 0; i < self.defaultItem.files.length; i++)
           {
             if (self.defaultItem.files[i].fileName.length >=50) {
               msg += 'Filename:' + self.defaultItem.files[i].fileName + ' should be less than 50 character long.\n';
             }
             if (self.defaultItem.files[i].fileSize > 1) {
                msg += 'Filename:' + self.defaultItem.files[i].fileName + ' size should be less than 1 MB.\n';
              }
              self.totalFileSize += self.defaultItem.files[i].fileSize
           }
           if (self.totalFileSize > 1)
           {
              msg += "Total File size exceeds 1 MB, please make sure the total file size is under 1 MB.\n";
           }
           
        }

      return msg;
    },

    changeTab(tabIndex) {
      //switch to the tab with key == tabIndex
      var self = this;
      self.tab = tabIndex;
    },

    productSelected() {
      debugger;
       var self = this;
       if (self.defaultItem.productId != self.otherProductId) {
         self.defaultItem.productName = '';
       }
    },

    sterilizationMethodSelected(){
      debugger;
       var self = this;
       if (self.defaultItem.sterilizationMethodId != self.otherSterilizationMethodId){
         self.defaultItem.sterilizationMethodName = "";
       }
    },

    purchasedFromLybDirectlySelected() {
      debugger;
       var self = this;
       if (self.purchaseDirectly == "Y"){
         self.defaultItem.distributorName = "";
         self.defaultItem.distributorCountry = "";
       }
    },

    DistributorOrConverterSelected()
    {
      debugger;
        var self=this;
        if(self.DistributorOrConverter == "Y")
        {
          self.purchaseDirectly ="Yes";    
        }
        else if(self.DistributorOrConverter == "N")
        {
          self.purchaseDirectly ="N";        
          self.defaultItem.distributorName = "";
          self.defaultItem.distributorCountry = "";          
        }
    },

    save() {
       
       //var test = this.isMedicalApplication;
       var self = this;
       self.isPageLoading = true;
       var validationMsg = self.validateFields();
       console.log(validationMsg);
      
      if (validationMsg != "") {
        self.addNotification({
                    type: "Error",
                    message: "Results",
                    description: validationMsg,
                    type: "red",
                    delay: 0,
                    top: true,
                    dismissable: true
                    });
        self.isPageLoading = false;
        self.totalFileSize = 0;
      } else {

      if (self.robot)  {
            self.addNotification({
                      type: "Error",
                      message: "Results",
                      description: "Please verify you are not a robot. Check the I am not robot checkbox. ",
                      type: "red",
                      delay: 0,
                      top: true,
                      dismissable: true
                      });
            self.isPageLoading = false;
            self.totalFileSize = 0;
            return;
            
        } 
        
        self.defaultItem.productPurchasedDirectly =
        self.purchaseDirectly == "N" ? false : true;
        self.defaultItem.IsDistributorOrConverter = self.DistributorOrConverter == "N" ? false : true;
        self.defaultItem.requestDate = new Date();
        self.defaultItem.createdDate = new Date();
        self.defaultItem.lastModifiedDate = new Date();
        self.defaultItem.isActive = 1;
        self.defaultItem.createdBy = self.defaultItem.submitterEmail;
        self.defaultItem.lastModifiedBy = self.defaultItem.submitterEmail;
        self.defaultItem.foodContactCompliant = self.defaultItem.productId == this.otherProductId ? false: true;
        
        console.log(self.defaultItem);
        const link = this.settings.odataUrl + "/Request";
        axios
          .post(link, self.defaultItem, {
            withCredentials: false,
            headers: self.requestHeaders,
          })
          //.post(link, self.defaultItem)
          .then(function (response) {
            debugger;
            var returnData = response.data;
            self.isPageLoading = false;
            //self.addNotification("Request created successfully, your request tracking id is: " + returnData.id);
            self.startAnother = true;  //show the start another request button
            self.addNotification({
                    type: "success",
                    message: "Results",
                    description: "Your request has been created successfully. Request ID: " + returnData.Id + "\n\n" +
                                 "To start another application, click on the button START ANOTHER APPLICATION",
                    type: "green",
                    delay: 0,
                    top: true,
                    dismissable: true
                    });
            // self.$toast.success(
            //    "Your request has been created successfully. Request ID: " + returnData.id + "\n\n" +
            //    "To start another application, click on the button START ANOTHER APPLICATION");
          })
          .catch((err) => {
            debugger;
            console.log("Error = " + err.response.data.message);
            self.addNotification({
                  type: "error",
                  message: "Results",
                  description: "A server error occurred while processing your request. Please contact the IT support team for assistance.",
                  type: "red",
                  delay: 0,
                  top: true,
                  dismissable: true
                  });
            // self.statusmessages.push(err.response.data.message);
            self.isPageLoading = false;
          }); 
        console.log(self.defaultItem);
      }
    },

    setUpForResubmit(){
        debugger;
        var self = this;
        //reset fields in product/application tab
        self.defaultItem.productId = -1;
        self.defaultItem.productSoldRegionId = -1;
        self.defaultItem.productEstimatedVolume = ' ';
        self.defaultItem.productUomId = -1;
        self.defaultItem.productApplicationId = -1;
        self.defaultItem.productClassificationId = -1;
        self.defaultItem.fdaCfrCitation = ' ';        
        self.defaultItem.OtherRegulatoryAuthority = ' ';
        self.defaultItem.SpecifyClassification = ' ';
        self.defaultItem.durationOfUseId = -1;
        self.defaultItem.sterilizationMethodId = -1;
        self.defaultItem.packagingTypeId = -1;
        self.defaultItem.routeOfAdministrationId = -1;
        self.defaultItem.applicationDetail = ' ';
        self.defaultItem.productName = ' ';
        self.defaultItem.applicationName = ' ';
        self.defaultItem.deviceTypeId = -1;
        self.defaultItem.files = [];
        self.fileinput = null;
        self.totalFileSize = 0;

        self.addNotification({
              type: "Information",
              message: "Results",
              description: "Your Contact Info and Converter/Distributor data is maintained, enter product info.",
              type: "blue",
              delay: 0,
              top: true,
              dismissable: true
              });
        self.startAnother = false;


    },
    async selectFile(allFiles) {
      debugger;
      var self = this;
      self.defaultItem.files = [];
      const filePathsPromises = [];
      if (allFiles != null && allFiles.length > 0) {
        //if (allFiles != null) {
        allFiles.forEach((file) => {
          filePathsPromises.push(this.toBase64(file));
        });
        const filePaths = await Promise.all(filePathsPromises);
        const mappedFiles = filePaths.map((base64File) => ({
          selectedFile: base64File,
        }));
        if (mappedFiles != null && mappedFiles.length > 0) {
          mappedFiles.forEach((mfile) => {
            debugger;
            var fItem = {};
            var tItem = mfile.selectedFile.split("##");
            fItem.fileName = tItem[0];
            var ttItem = tItem[1].split(";");
            fItem.fileMimeType = ttItem[0].replace("data:", "");
            fItem.fileByteData = ttItem[1].replace("base64,", "");
            fItem.fileSize = Math.ceil(fItem.fileByteData.length / 4) * 3 / 1024 / 1024;
            self.defaultItem.files.push(fItem);
          });
        }
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(file.name + "##" + reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

  },

  // isPackagingApplication() {
  //   debugger;
  //   var isPackaging = false;
  //    if (this.productApplicationId ==2)
  //    {
  //      isPackaging = true;
  //    }
  //    return isPackaging;
  // },
  // isOtherApplication() {
  //   var isOther = false;
  //    if (this.productApplicationId ==3)
  //    {
  //      isOther = true;
  //    }
  //    return isOther;
  // },

  // isSoldNorthAmerica() {
  //   var isNorthAmerica = false;
  //   if (this.productSoldRegionId == 3)
  //   {
  //     isNorthAmerica = true;
  //   }
  //   return isNorthAmerica;
  // },
  // isOtherSterilizationMethod() {
  //   var isOtherSterilization = false;
  //   if (this.sterilizationMethodId == 3)
  //   {
  //     isOtherSterilization = true;
  //   }
  //   return isOtherSterilization;
  // },

  // hasAdminAccess() {
  //   // var adminaccess = false;
  //   // var filterUser = [];
  //   // filterUser = this.useraccess.filter(
  //   //   (x) => x.plant == "Global" || x.company == "LYB"
  //   // );
  //   // if (filterUser != null && filterUser.length > 0) {
  //   //   adminaccess = true;
  //   // }
  //   return true;
  // },

  watch: {
    // isLoggedIn(newVal) {
    //   if (newVal) {
    //     this.init();
    //   }
    // },
  },
};
</script>

<style>
#DQPTable table tr th {
  vertical-align: text-top !important;
  padding-top: 10px !important;
  font-weight: bolder !important;
  font-size: 14px;
  background-color: #1976d226;
}

.v-tab {
  text-transform: none !important;
  font-size: 18px;
  font-weight: bolder;
}
/* .v-text-field{
      width: 200px;
} */
</style>
